import {ComponentRegistry} from '../../components/component-registry';
import {DataApi} from '../../api/data-api/data-api';
import {AbstractFilter} from '../abstract-filter';
import {EventFilter, EventSettings, Filter} from './filter';
import {AbstractPaginatedList} from '../abstract-paginated-list';

/**
 * Event list.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class List extends AbstractPaginatedList<EventFilter, EventSettings> {
  constructor(container: HTMLElement) {
    super(container);

    ComponentRegistry.wait<Filter>('event-filter')
      .then(filterPlugin => {
        this.find(filterPlugin.filter);
        filterPlugin.emitter.on('change', () => {
          this.pagination.browse(0);
        });
        this.pagination.emitter.on('browse', paginationSettings => {
          this.settings.start = paginationSettings.start;
          this.find(filterPlugin.filter);
        });
      });

    ComponentRegistry.add('event-list', this);
  }

  /**
   * Finds events.
   *
   * @param {EventFilter} filter Filter
   */
  protected find(filter: EventFilter | null): void {
    filter = AbstractFilter.isFilterEmpty<EventFilter>(filter) ? null : filter;
    DataApi.instance.eventEndpoint.find(this.settings, filter)
      .then(response => {
        if (this.isResultEmpty(response)) {
          this.empty();
          return;
        }

        let html = '';
        let i = 0;
        for (const document of response.documents) {
          const template = require('../../handlebars/templates/event/item.handlebars');
          html += template({
            document: document,
            isLast: i === response.documents.length - 1,
            iteration: i++
          });
        }
        this.update(html);

        this.pagination.settings.numFound = response.numFound;
        this.pagination.update();

        this.emitter.emit('change', this);
      })
      .catch(e => {
        this.error(e);
      });
  }
}
